export default __webpack_public_path__ + "static/media/nabillogo.28873561.png";